import React, { useEffect, useState } from 'react';
import { List, ListItem } from '@material-ui/core';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';

import DocumentPresenter from 'presenters/DocumentPresenter';
import DatasetFieldPresenter from 'presenters/DatasetFieldPresenter';
import MapDropdownItem from 'containers/MapData/components/MapDropdownItem';
import { useDocuments } from 'slices/hooks';

import useStyles from './useStyles';

const MapDropdownContent = (props) => {
  const { onMapField, fields, mapToIndex } = props;
  const [requiredFields, setRequiredFields] = useState([]);
  const [otherFields, setOtherFields] = useState([]);
  const { currentDocument } = useDocuments();

  const classes = useStyles();

  useEffect(() => {
    setRequiredFields(fields.filter((field) => DatasetFieldPresenter.isRequired(field)));
    setOtherFields(fields.filter((field) => !DatasetFieldPresenter.isRequired(field)));
  }, [fields]);

  return (
    <div className={classes.root}>
      {isEmpty(fields) ? (
        <div className={classes.hint}>no fields available</div>
      ) : (
        <>
          {!isEmpty(requiredFields) && (
            <List className={classes.list}>
              <ListItem className={classes.listTitle}>
                Required Fields: {DocumentPresenter.dataset(currentDocument).name}
              </ListItem>
              {requiredFields.map((field) => (
                <MapDropdownItem key={field.id} onMapField={onMapField} field={field} mapToIndex={mapToIndex} />
              ))}
            </List>
          )}
          {!isEmpty(otherFields) && (
            <List className={classes.list}>
              <ListItem className={classes.listTitle}>All Available Fields</ListItem>
              {otherFields.map((field) => (
                <MapDropdownItem key={field.id} onMapField={onMapField} field={field} mapToIndex={mapToIndex} />
              ))}
            </List>
          )}
        </>
      )}
    </div>
  );
};

MapDropdownContent.propTypes = {
  onMapField: PropTypes.func,
  fields: PropTypes.arrayOf(DatasetFieldPresenter.shape()),
  mapToIndex: PropTypes.number.isRequired,
};

MapDropdownContent.defaultProps = {
  onMapField: () => {},
  fields: [],
};

export default MapDropdownContent;
